// extracted by mini-css-extract-plugin
export default {"isContainer":"text_isContainer__1ny27","container":"text_container__1_TEJ"};